/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

/**
 * Per-publication availability status derived from date columns.
 *
 * A pure function of ``available_ranges``, ``published_at``, ``accessible_from``,
 * ``first_available_from`` and ``NOW()``.
 */
export type AvailabilityStatus = typeof AvailabilityStatus[keyof typeof AvailabilityStatus];


export const AvailabilityStatus = {
  coming_soon: 'coming_soon',
  early_access: 'early_access',
  new_release: 'new_release',
  recently_added: 'recently_added',
  leaving_soon: 'leaving_soon',
  available: 'available',
  unavailable: 'unavailable',
} as const;
